<script setup lang="ts">
import { watchEffect, toRaw, ref } from 'vue'
import { Snake } from '../../server-src/model'

interface SnakeWithMaybeNumber extends Snake {
  number?: number | string
}

const props = defineProps<{
  leaderboard: SnakeWithMaybeNumber[] | undefined
}>()
</script>

<style scoped>
.leaderboard {
  position: fixed;
  opacity: 50%;
  background-color: lightgreen;
  height: 8rem;
  width: 8rem;
  font-size: 15px;
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>

<template>
  <div class="leaderboard" v-show="leaderboard?.length">
    <TransitionGroup name="list" tag="ol">
      <li v-for="s in leaderboard" :key="s.id">
        {{ s.name }}<span v-if="s.number != null">: {{ s.number }}</span>
      </li>
    </TransitionGroup>
  </div>
</template>
